import { styled } from "@mui/material/styles";
import { Separator } from "react-resizable-panels";

type PanelOrientation = "horizontal" | "vertical";

const StyledSeparator = styled(Separator, {
  shouldForwardProp: (prop) => prop !== "panelOrientation",
})<{ panelOrientation: PanelOrientation }>(({ theme, panelOrientation }) => {
  const isVertical = panelOrientation === "vertical";
  return {
    ...(isVertical
      ? {
          height: 8,
          cursor: "row-resize",
          marginTop: 4,
          marginBottom: 4,
        }
      : {
          width: 8,
          cursor: "col-resize",
          marginLeft: 5,
          marginRight: 5,
        }),
    background: theme.palette.grey[300],
    position: "relative" as const,
    borderRadius: 10,
    transition: isVertical
      ? "height 0.1s, background 0.1s"
      : "width 0.1s, background 0.1s",
    "&:hover": {
      ...(isVertical ? { height: 10 } : { width: 10 }),
      background: theme.palette.grey[400],
      "& .separator-grip": {
        background: theme.palette.grey[700],
      },
    },
    "& .separator-grip": {
      position: "absolute" as const,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      ...(isVertical ? { width: 40, height: 3 } : { width: 3, height: 40 }),
      background: theme.palette.grey[500],
      borderRadius: 2,
      transition: "background 0.1s",
    },
  };
});

interface Props {
  onDoubleClick: () => void;
  orientation?: PanelOrientation;
}

export const ResizablePanelSeparator = ({
  onDoubleClick,
  orientation = "horizontal",
}: Props) => (
  <StyledSeparator onDoubleClick={onDoubleClick} panelOrientation={orientation}>
    <div className="separator-grip" />
  </StyledSeparator>
);
